export const enFeaturesLabels = {
  buttons: {},
  navigation: {},
  roleModules: {},
  toast: {},
};
